import styled from "styled-components";

export const PlayerWrapper = styled.div`
  width: 100%;
  ${'' /* max-width: 380px; */}
  padding: 18px 20px;
  border-radius: 16px;
  font-family: lato;
  border-radius: 8px;
  border: 0.75px solid #DCDCDC;
  background: #F8F8F8;
  margin: ${({margin}) => margin && margin};
  ${'' /* box-shadow: 0 4px 12px #DCDCDC; */}
`;

export const AudioTitle = styled.div`
  font-size: 18px;
  font-weight: 600;
  margin-bottom: 14px;
  color: #333;
`;

export const ControlsRow = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  margin-top:20px;


  .play-time{
    color:#184A61;
  }

  .total-time{
    color:#;
  }
`;

export const ControlsRowV1 = styled.div`
  width:100%;
  margin-top:20px;

  .time-row{
    display:flex;
    justify-content:space-between;
    align-items:center;
    margin-top:8px;
  }

  .play-time{
    color:#184A61;
    font-family:Lato;
    font-size:16px;
    font-weight:400;
    line-height:20px;
  }

  .total-time{
    color:#184A61;
    font-family:Lato;
    font-size:16px;
    font-weight:400;
    line-height:20px;
  }
`;

export const PlayButton = styled.div`
  display:flex;
  align-items:center;
  justify-content:${({ displayNone,  }) =>
    displayNone  ? "center" : "space-between"};
  ${'' /* justify-content:space-between; */}
  color: #184A61;
  font-family: Lato;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 18px;

  .first-row{
    display:flex;
    align-items:center;
  }

  .center-row{
    display:flex;
    align-items:center;
    margin:auto;
  }

  .normal-row{
    display:flex;
    align-items:center;
    margin:auto;
  }

  .play-button{
    display:flex;
    cursor:pointer;
  }

  .play-time{
    margin-left:12px;
    color: #184A61;

  }

  .total-time{
    color: #184A61;
  }

  .volume-icon{
    margin-right:8px;
  }

  .listen-text{
    color:#184A61;
    font-family: Lato;
    font-size: 16px;
    font-style: normal;
    font-weight: 700;
    line-height: 20px; 
  }

  .hidden-text{
  visibility:hidden;
}
  
`;

export const ProgressWrapper = styled.div`
  flex: 1;
  display:flex;
  align-items:center;
`;

export const ProgressBar = styled.input`
  width: 100%;
  cursor: pointer;
  ${'' /* margin-bottom: 6px; */}

  -webkit-appearance: none;
  appearance: none;
  height: 6px;
  border-radius: 4px;
  background: #ddd;

  &::-webkit-slider-thumb {
    -webkit-appearance: none;
    height: 14px;
    width: 14px;
    background: #DA6C74;
    border-radius: 50%;
    ${'' /* border: 2px solid white; */}
    ${'' /* box-shadow: 0px 0px 4px rgba(0,0,0,0.3); */}
  }

  &::-moz-range-thumb {
    height: 14px;
    width: 14px;
    background: #3b82f6;
    border-radius: 50%;
    border: none;
  }
`;

export const VolumeProgressBar = styled.input`
  width: 100%;
  cursor: pointer;
  ${'' /* margin-bottom: 6px; */}

  -webkit-appearance: none;
  appearance: none;
  height: 4px;
  border-radius: 4px;
  background: #ddd;

  &::-webkit-slider-thumb {
    -webkit-appearance: none;
    height: 0px;
    width: 0px;
    background: #DA6C74;
    border-radius: 50%;
    ${'' /* border: 2px solid white; */}
    ${'' /* box-shadow: 0px 0px 4px rgba(0,0,0,0.3); */}
  }

  &::-moz-range-thumb {
    height: 0px;
    width: 0px;
    background: #3b82f6;
    border-radius: 50%;
    border: none;
  }
`;

